<template>
  <h1 v-if="isStarting">Starting connection to WebSocket Server</h1>
  <h1 v-if="isSuccess">Successfully connected to the echo WebSocket server...</h1>
  <div v-for="(item, index) in eventData" :key="index">
    <p>Event Name: {{ item.event }}</p>
    <p>Data: {{ item.data }}</p>
    <p>----------</p>
  </div>
</template>
  
<script>
import { ref, onMounted } from 'vue';

export default {
  setup() {
    const eventData = ref([]);
    var isStarting = ref(false)
    var isSuccess = ref(false)

    const initSocket = () => {
      isStarting.value = true
      console.log("Starting connection to WebSocket Server");
      const connection = new WebSocket("wss://dev-sis-number.bitville.dev");

      connection.onmessage = (event) => {
        if (!eventData.value) {
          eventData.value = [];
        }
        const jsonString = event.data;
        const jsonObject = JSON.parse(jsonString);
        eventData.value.push(jsonObject);
        console.log("eventData", eventData.value);
        console.log("look, I got something from the server");
        console.log(event.data);
      };

      connection.onopen = (event) => {
        console.log(event);
        console.log("Successfully connected to the echo WebSocket server...");
        isSuccess.value = true;
      };
    };

    onMounted(() => {
      initSocket();
    });

    return {
      eventData,
      isStarting,
      isSuccess
    };
  },
};
</script>
  